import { useTranslation } from 'react-i18next'

import { getActionSelectOptions } from '../../../../Action'
import { BirdviewChartAction } from '../../../DashboardBirdview.constants.charts'
import { BIRDVIEW_CHART_OBJECT_TARGET } from '../../../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../../../DashboardBirdview.hooks'
import {
  getBirdviewChartActions,
  getBirdviewNextChartOptionValue,
} from '../../BirdviewChartCard.utils'

export function useBirdviewChartCardActions({
  chart,
  period,
  periodOptions,
  onChangeControls,
  onCycleSize,
  onNavigate,
  onRemove,
}) {
  const { t } = useTranslation()

  const { getListTarget } = useBirdviewListTarget()

  function handleOpen(event) {
    onNavigate({
      event,
      link: getListTarget(BIRDVIEW_CHART_OBJECT_TARGET[chart.object]),
    })
  }

  function handleClickAction({ value }) {
    switch (value) {
      case BirdviewChartAction.Period:
        onChangeControls(chart.sectionKey, {
          period: getBirdviewNextChartOptionValue(periodOptions, period.value),
        })
        break
      case BirdviewChartAction.Size:
        onCycleSize(chart.id)
        break
      case BirdviewChartAction.Open:
        handleOpen()
        break
      default:
        onRemove(chart.id)
    }
  }

  return {
    actions: getActionSelectOptions({
      actions: getBirdviewChartActions(chart),
      t,
    }),
    handleClickAction,
    handleOpen,
  }
}
